import React from 'react';
import {Referral} from 'placement/domains';
import {Icon, ChevronLeftIcon} from 'evergreen-ui'
import {useGoToReferralListPage} from 'placement/routes';
import {BehaviorSubject} from 'rxjs';
import {useObservable} from "../../rxsupport";

type Props = {
    selectedReferral$: BehaviorSubject<Referral | null>;
}

export function ProviderOfferNavigationBar({selectedReferral$}: Props) {
    const selectedReferral = useObservable<Referral | null>(selectedReferral$, selectedReferral$.getValue());
    const referral = selectedReferral!;
    const goToReferralListPage = useGoToReferralListPage();

    const backToReferralList = React.useCallback(
        () => {
            goToReferralListPage();
        },
        [goToReferralListPage]
    );

    return (
        <div className='p-5' data-testid="provider-offer-navigation-bar">
            <div className='p-5 flex items-center h-20 text-black bg-white shadow-md'>
                <div className='w-3/12 flex items-center'>
                    <div className='w-12 h-12 flex items-center rounded-full hover:bg-gray-200'
                         onClick={() => backToReferralList()}
                         data-testid="provider-offer-navigation-bar-back-btn"
                    >
                        <Icon paddingRight={'5px'} margin={'auto'} icon={ChevronLeftIcon} size={32}/>
                    </div>
                    <div className='flex flex-col'>
                        <div className='align-middle'>
                            <span className='text-xl font-semibold pr-5'>
                                {referral.clientName}
                            </span>
                            <a href={referral.salesforceCaseUrl} target="_blank" rel="noopener noreferrer">
                                <span className='underline text-blue-portal-link'>
                                    {referral.caseNumber}
                                </span>
                            </a>
                        </div>
                        <div className='flex items-center text-gray-600 text-sm font-medium whitespace-no-wrap'>
                            <span className='font-semibold'>
                                Age: <span className='font-medium'>{referral.clientAge ?? 'None'}</span>
                            </span>
                            <span className='px-2'>&#8226;</span>
                            <span>
                                {referral.location ?? 'None'}
                            </span>
                        </div>
                    </div>
                </div>
                <div className='w-9/12 flex leading-5 justify-end'>
                    <p className='pr-2 font-semibold'>
                        Type
                    </p>
                    <p className='pr-5 whitespace-no-wrap'>
                        {referral.placementType ?? 'None'}
                    </p>
                    <p className='pr-2 font-semibold'>
                        Service
                    </p>
                    <p className='pr-5 line-clamp-2'>
                        {referral.serviceTypes.join(', ') ?? 'None'}
                    </p>
                    <p className='pr-2 font-semibold whitespace-no-wrap'>
                        Preferred Language
                    </p>
                    <p className='pr-5'>
                        {referral.requiredLanguage ? referral.requiredLanguage : 'None'}
                    </p>
                    <p className='pr-2 font-semibold whitespace-no-wrap'>
                        Days in Placement
                    </p>
                    <p className='pr-5'>
                        {referral.daysInPlacement ?? 'None'}
                    </p>
                </div>
            </div>
        </div>
    );
}
